import { render, staticRenderFns } from "./TUICallKit.vue?vue&type=template&id=5bf11fe2&scoped=true"
import script from "./TUICallKit.vue?vue&type=script&lang=js"
export * from "./TUICallKit.vue?vue&type=script&lang=js"
import style0 from "./TUICallKit.vue?vue&type=style&index=0&id=5bf11fe2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf11fe2",
  null
  
)

export default component.exports